import {RepositoryFactory} from '@/repository/RepositoryFactory';

const InvoiceRepository = RepositoryFactory.get('invoice');

export default {
  state: {
    invoices: [],
    invoice_meta: {},
  },
  mutations: {
    SET_INVOICES: (state, { data, meta }) => {
      state.invoices = data
      state.invoice_meta = meta
    },
  },
  getters: {
    invoices: state => state.invoices,
    invoice_meta: state => state.invoice_meta,
  },
  actions: {
    async fetchAllInvoices({commit}, { page, filterQuery, perPage }) {
      const { data } = (await InvoiceRepository.getListOfAllInvoices(page, filterQuery, perPage))
      commit('SET_INVOICES', data );
    },
    async fetchSampleInvoices({commit}, { page, filterQuery, perPage }) {
      const { data } = (await InvoiceRepository.getListOfSampleInvoices(page, filterQuery, perPage))
      commit('SET_INVOICES', data );
    },
  }
}
